import MuiMenu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export default function Menu({
  open,
  anchorEl,
  handleClose,
  menuWrapper,
}: {
  open: boolean;
  anchorEl: null | HTMLElement;
  menuWrapper?: JSX.Element;
  handleClose: () => void;
}) {
  return (
    <MuiMenu
      id="demo-positioned-menu"
      aria-labelledby="demo-positioned-button"
      anchorEl={anchorEl}
      open={open}
      sx={{
        ".MuiPopover-paper": {
          boxShadow: "none",
          backgroundColor: "transparent !important",
          transform: "translateY(22px) !important",
        },
      }}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
    >
      {menuWrapper ? (
        menuWrapper
      ) : (
        <MenuItem onClick={handleClose}>Profile</MenuItem>
      )}
    </MuiMenu>
  );
}
